import { useMemo } from "react";
import { CustomTable } from "../../componentes/table/CustomTable";

function TabelaRotasFinalizadas({ data, onRowClick, loading, ano, mes }) {

    const columns = useMemo(() => [
        {
            key: "filialNome",
            label: "Filial",
            sortable: true,
        },
        {
            key: "funcionarioCodigo",
            label: "Cód. Func.",
            sortable: true,
            center: true,
        },
        {
            key: "funcionarioNome",
            label: "Funcionário",
            sortable: true,
        },
        {
            key: "funcionarioCargo",
            label: "Cargo",
            sortable: true,
        },
        {
            key: "quantidadesEscalasDeRota",
            label: "Escalas",
            sortable: true,
            center: true,
            className: "bg-muted",
        },
        {
            key: "rotas24Horas",
            label: "Rota 24h",
            sortable: true,
            center: true,
            className: "bg-primary/5",
        },
        {
            key: "rotas48Horas",
            label: "Rota 48h",
            sortable: true,
            center: true,
            className: "bg-primary/5",
        },
        {
            key: "totalRotas",
            label: "Rotas Greenmile",
            sortable: true,
            center: true,
            className: "font-semibold bg-primary/10",
        },
        {
            key: "rotasNoPrazo",
            label: "No Prazo",
            sortable: true,
            center: true,
            className: "font-semibold",
        },
        {
            key: "percentualConclusao",
            label: "% Conclusão",
            sortable: true,
            center: true,
            className: "font-semibold bg-success/5",
            render: (item) => item != null ? `${Number(item).toFixed(2)}%` : "—",
        },
        {
            key: "rotasComImagem",
            label: "Com Imagem",
            sortable: true,
            center: true,
            className: "font-semibold bg-primary/5",
        },
        /*
        {
            key: "rotas1Aux",
            label: "1 Aux",
            sortable: true,
            center: true,
            className: "bg-violet-50",
        },
        {
            key: "rotas2Aux",
            label: "2 Aux",
            sortable: true,
            center: true,
            className: "bg-violet-50",
        },
        {
            key: "rotasFrete",
            label: "Frete",
            sortable: true,
            center: true,
            className: "bg-muted",
        },
        */
        {
            key: "percentualGreenmile",
            label: "% Greenmile",
            sortable: true,
            center: true,
            className: "font-semibold bg-success/5",
            render: (item) => item != null ? `${Number(item).toFixed(2)}%` : "—",
        },
    ], []);

    return (
        <div>
            <CustomTable
                data={data}
                columns={columns}
                showHeader={false}
                loading={loading}
                exportable={true}
                exportFilename={`Acompanhamento de Rotas Finalizadas ${ano}-${mes}`}
                maxHeight="calc(100vh - 212px)"
                className="text-[11px]"
                onRowSelect={(row) => onRowClick?.(row)}
                footer={(rows) => {
                                     return (
                        <div className="flex flex-wrap justify-end gap-5 p-2 text-xs font-semibold text-foreground">
                         
                        </div>
                    );
                }}
            />
        </div>
    );
}

export default TabelaRotasFinalizadas;
